import { CoordenatesPage } from '../envelope/model/coordenates-page';
import { CustomFieldTypeEnum } from '../enum/custom-field-type.enum';

const SIGNATURE_WIDTH = 50;
const SIGNATURE_HEIGHT = 20;
const MARGIN = 2;
const QUANTITY_OF_SIGNATURE_DEFAULT = 4;
const QUANTITY_OF_SIGNATURE_HEIGHT_DEFAULT = 48;
const HEIGHT_BASE_BOARD = 10;

const RUBRIC_WIDTH = 14;
const RUBRIC_HEIGHT = 12;
const RUBRIC_MARGIN = 2;
const RUBRIC_MARGIN_TOP = 2;
const QUANTITY_OF_RUBRICS_DEFAULT = 21;
const RUBRIC_HEIGHT_BASE_BOARD = 20;

export class PageUtil {
  public static signatureStampHeightInMm = 20.27;
  public static rubricStampHeightInMn = 12.33;

  public static calculateCoordenatesOnPageMM(widthInPx, order, page) {

    const widthInMm = Math.round(widthInPx / 3.78);

    const quantityRubricsOnPage = widthInMm > 0 ?
      this.getQuantityOfSignatureOnPage(MARGIN, SIGNATURE_WIDTH, widthInMm) : QUANTITY_OF_SIGNATURE_DEFAULT;
    const xValue = MARGIN + (((order - 1) % quantityRubricsOnPage) * SIGNATURE_WIDTH);
    const yValue = (MARGIN + HEIGHT_BASE_BOARD) + ((Math.floor((order - 1) / quantityRubricsOnPage)) * SIGNATURE_HEIGHT);

    return new CoordenatesPage(xValue, yValue, page);
  }

  public static calculateCoordenatesDefaultSignatureOnPagePx(heightInPx: number, widthInPx: number, order: number, page: number) {

    const quantityRubricsOnPage = widthInPx > 0 ?
      this.getQuantityOfSignatureOnPage(10, 189, widthInPx) : QUANTITY_OF_SIGNATURE_DEFAULT;

    const quantityRubricsOnPageHeight = heightInPx > 0 ?
      this.getQuantityOfSignatureOnPageHeight(5, 85, heightInPx) : QUANTITY_OF_SIGNATURE_HEIGHT_DEFAULT;

    if (order > (quantityRubricsOnPageHeight * quantityRubricsOnPage)) {
      page--;
    }

    const xValue = 7.55 + (((order - 1) % quantityRubricsOnPage) * 189);
    const currentOrder = Math.floor((order - 1) / quantityRubricsOnPage)
    const yPosition = currentOrder * 85;
    const yMargin = yPosition > 0 ? (currentOrder * 9.4) : -10;
    const yValue = (heightInPx - 130) - (yPosition - (yMargin > 0 ? yMargin : -yMargin));
    return new CoordenatesPage(xValue, yValue, page.toString(), yMargin);
  }

  public static calculateCoordenatesDefaultRubricOnPagePx(heightInPx: number, widthInPx: number, order: number) {
    const RUBRIC_HEIGHT_PX = 50;
    const RUBRIC_WIDTH_PX = 60;
    const RUBRIC_MARGIN_WIDTH_PX = 10;
    const RUBRIC_MARGIN_TOP_PX = 10;

    const quantityRubricsOnPage = heightInPx > 0 ?
      this.getQuantityOfRubricsOnPage(RUBRIC_MARGIN_WIDTH_PX, RUBRIC_HEIGHT_PX, heightInPx) : QUANTITY_OF_RUBRICS_DEFAULT;

    const orderWidth = order / (quantityRubricsOnPage + 1);
    const xValue = (widthInPx - RUBRIC_WIDTH_PX) - RUBRIC_MARGIN_WIDTH_PX -
      ((parseInt(orderWidth.toString(), 10) % quantityRubricsOnPage) * RUBRIC_WIDTH_PX) - 5;

    const qtde = order / quantityRubricsOnPage;
    const positionOrder = (order > quantityRubricsOnPage ? (order - (quantityRubricsOnPage * parseInt(qtde.toString()))) : order - 1);
    const yValue = Math.floor(positionOrder * RUBRIC_HEIGHT_PX) + RUBRIC_MARGIN_TOP_PX;
    return new CoordenatesPage(xValue, yValue, '0');
  }

  public static calculateCoordenatesRubricOnPage(widthInPx, heightInPx, order) {
    const widthInMm = Math.round(widthInPx / 3.78);
    const heightInMm = Math.round(heightInPx / 3.78);
    const adjustMarginX = 4;
    const adjustMarginY = 4;

    const quantityRubricsOnPage = heightInMm > 0 ?
      this.getQuantityOfRubricsOnPage(RUBRIC_MARGIN, RUBRIC_HEIGHT, heightInMm) : QUANTITY_OF_RUBRICS_DEFAULT;

    const orderWidth = order / (quantityRubricsOnPage + 1);
    const xValue = (widthInMm - RUBRIC_WIDTH) - RUBRIC_MARGIN -
      ((parseInt(orderWidth.toString(), 10) % quantityRubricsOnPage) * RUBRIC_WIDTH) - adjustMarginX;

    const positionOrder = (order > quantityRubricsOnPage ? (order - (quantityRubricsOnPage + 1)) : order);
    const yValue = heightInMm - (RUBRIC_MARGIN_TOP + RUBRIC_HEIGHT_BASE_BOARD) - (
      Math.floor(positionOrder * RUBRIC_HEIGHT)) + adjustMarginY;

    return new CoordenatesPage(xValue, yValue, '0');
  }

  public static recalculatesCoordinatesForBry(heightInPixel: any, coordanteY: any, stampHeightInMm: any) {
    const heightInMm = Math.round(((heightInPixel / 3.787) + Number.EPSILON) * 100) / 100;
    let newCoordinatesY = (heightInMm - coordanteY - stampHeightInMm)
    return newCoordinatesY > 0 ? newCoordinatesY.toFixed(2) : coordanteY
  }

  public static recalculatesCoordinatesBryBySign(heightInPixel: any, coordanteY: any, stampHeightInMm: any) {
    const heightInMm = Math.round((heightInPixel + Number.EPSILON) * 3.78);
    const newCoordinatesY = heightInMm - coordanteY - stampHeightInMm;
    return newCoordinatesY > 0 ? newCoordinatesY.toFixed(2) : coordanteY;
  }

  public static getQuantityOfSignatureOnPageHeight(margin, signatureHeight, heightInMm) {
    return Math.floor(heightInMm / (margin + signatureHeight));
  }

  public static getQuantityOfSignatureOnPage(margin, rubricWidth, widthInMm) {
    return Math.floor(widthInMm / (margin + rubricWidth));
  }

  public static setCustomFieldTypeInt(customFieldType: CustomFieldTypeEnum): number {
    switch (customFieldType) {
      case CustomFieldTypeEnum.TextField:
        return 1;
      case CustomFieldTypeEnum.CheckboxField:
        return 2;
      default:
        return 1;
    }
  }

  public static setCustomFieldTypeByType(customFieldType: number): CustomFieldTypeEnum {
    switch (customFieldType) {
      case 1:
        return CustomFieldTypeEnum.TextField;
      case 2:
        return CustomFieldTypeEnum.CheckboxField;
      default:
        return CustomFieldTypeEnum.TextField;
    }
  }

  private static getQuantityOfRubricsOnPage(margin, rubricHeight, heightInMm) {
    return Math.floor(heightInMm / (margin + rubricHeight));
  }
}
